import './EditWhileReadingStyle.css';
import { Language, Sentence } from "../../../../rest/models";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { Button, TextArea } from "../../../RequestRespectingInputs";
import { bookReaderActions } from "../slice";
import { EWRSentenceTranslationTextBoxClass } from "./EWRSentenceEditor";

export function EWRTranslationEditor(props: Props)
{
    const appDispatch = useAppDispatch();
    const l = props.language;
    const sen = props.sentence;
    const trans = useAppSelector(state => state.bookReader.translationsByLangAndSentence[l.id + '/' + sen.sentence_id] ?? '');
    const isSource = useAppSelector(state => state.bookReader.book.source_language === l.id);
    const legend = l.name + (isSource ? ' (Source)' : '');

    const gtrans_code = encodeURIComponent(l.gtrans_code);
    const original = encodeURIComponent(sen.text || '');

    const url = `https://translate.google.com/?sl=auto&tl=${gtrans_code}&text=${original}&op=translate`;

    return (
        <fieldset className='ernots_EWRSentenceTranslationEditor' key={props.booklanguage_id}>
            <legend>{legend}</legend>
            <TextArea
                className={EWRSentenceTranslationTextBoxClass}
                data-language_id={l.key}
                value={trans}
                onChange={e => appDispatch(bookReaderActions.setTranslation([
                    l.id,
                    sen.sentence_id,
                    e.target.value
                ]))}
                />
            
            {isSource ? <></> : <> <Button onClick={e => window.open(url, '_blank')}>Open Translation</Button></>}
        </fieldset>
    );
}

interface Props
{
    sentence: Sentence;
}

interface Props
{
    booklanguage_id: string;
    language: Language;
    sentence: Sentence;
}